<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-2">
          <!-- <base-input> -->
          <el-select
            class="select-primary mb-3 pagination-select"
            v-model="light" filterable
          >
            <el-option
              v-for="select in lights"
              class="select-primary"
              :value="select.value"
              :label="select.label"
              :key="select.label"
            ></el-option>
          </el-select>
          <!-- </base-input> -->
        </div>
        <div class="col-lg-5">
          <!-- <base-input> -->
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            @input="validateEndDate"
          >
          </el-date-picker>
          <!-- </base-input> -->
        </div>
        <div class="col-lg text-right">
          <base-button class="btn-success text-default"
            >Export to CSV
          </base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg d-flex">
          <!-- light profile  -->
          <card type="card-chart">
            <h3 class="text-center">LIGHT PROFILE</h3>

            <div
              class="row text-center card-description"
              style="padding: 50px 0"
            >
              <div class="col-lg text-inline">
                <img src="@/assets/img/Vectolabs Primelux.png" width="70%" />
              </div>
            </div>

            <div class="row text-center card-description">
              <div class="col-lg text-inline">Maker</div>
              :
              <div class="col-lg text-left text-inline">Primelux</div>
            </div>
            <div class="row text-center card-description">
              <div class="col-lg">Model</div>
              :
              <div class="col-lg text-left">Aries 80w</div>
            </div>
            <div class="row text-center card-description">
              <div class="col-lg">Wattage</div>
              :
              <div class="col-lg text-left">80w</div>
            </div>
            <div class="row text-center card-description">
              <div class="col-lg">Pole No</div>
              :
              <div class="col-lg text-left">006</div>
            </div>
            <div class="row text-center card-description">
              <div class="col-lg">Type of light</div>
              :
              <div class="col-lg text-left">LED street light</div>
            </div>
            <div class="row text-center card-description">
              <div class="col-lg">Warranty</div>
              :
              <div class="col-lg text-left">5 years</div>
            </div>
            <div class="row text-center card-description">
              <div class="col-lg">Installed date</div>
              :
              <div class="col-lg text-left">15 August 2018</div>
            </div>
          </card>
        </div>
        <div class="col-lg">
          <div class="row">
            <!-- total cost -->
            <div class="col-lg">
              <card type="card-chart" style="height: 250px">
                <div class="row">
                  <div class="col-lg-10" style="display: inline">
                    <h3 class="text-center">TOTAL COST (MYR)</h3>
                  </div>
                  <div class="col-lg" style="display: inline; left: 0px">
                    <img src="@/assets/img/Total Cost Icon.png" width="70px;" />
                  </div>
                </div>
                <br />
                <h1
                  class="text-center"
                  style="font-size: 45px; padding: 20px 0"
                >
                  3020.50
                </h1>
              </card>
            </div>
          </div>
          <div class="row">
            <!-- total cost graph -->
            <div class="col-lg">
              <card type="card-chart">
                <div class="row">
                  <div class="col-lg" style="display: inline">
                    <h3 class="text-center">TOTAL COST</h3>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-lg">
                    <line-chart
                      :chart-data="lineChart1.chartData"
                      :gradient-colors="lineChart1.gradientColors"
                      :gradient-stops="lineChart1.gradientStops"
                      :extra-options="lineChart1.extraOptions"
                      :height="200"
                    >
                    </line-chart>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
        <div class="col-lg">
          <div class="row">
            <!-- total energy -->
            <div class="col-lg">
              <card type="card-chart" style="height: 250px">
                <div class="row">
                  <div class="col-lg-10" style="display: inline">
                    <h3 class="text-center">TOTAL ENERGY</h3>
                  </div>
                  <div class="col-lg" style="display: inline; left: 0px">
                    <img src="@/assets/img/Energy Icon.png" width="70px;" />
                  </div>
                </div>
                <br />
                <h1
                  class="text-center"
                  style="font-size: 45px; padding: 20px 0"
                >
                  5500
                </h1>
              </card>
            </div>
          </div>
          <div class="row">
            <!-- total brightness level graph -->
            <div class="col-lg">
              <card type="card-chart">
                <div class="row">
                  <div class="col-lg" style="display: inline">
                    <h3 class="text-center">BRIGHTNESS LEVEL</h3>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-lg">
                    <line-chart
                      :chart-data="lineChart2.chartData"
                      :gradient-colors="lineChart2.gradientColors"
                      :gradient-stops="lineChart2.gradientStops"
                      :extra-options="lineChart2.extraOptions"
                      :height="200"
                    >
                    </line-chart>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg d-flex">
          <!-- voltage -->
          <card type="card-chart">
            <div class="row">
              <div class="col-lg" style="display: inline">
                <h3 class="text-center">VOLTAGE</h3>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg">
                <line-chart
                  :chart-data="lineChart3.chartData"
                  :gradient-colors="lineChart3.gradientColors"
                  :gradient-stops="lineChart3.gradientStops"
                  :extra-options="lineChart3.extraOptions"
                  :height="200"
                >
                </line-chart>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg d-flex">
          <!-- current -->
          <card type="card-chart">
            <div class="row">
              <div class="col-lg" style="display: inline">
                <h3 class="text-center">CURRENT</h3>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg">
                <line-chart
                  :chart-data="lineChart4.chartData"
                  :gradient-colors="lineChart4.gradientColors"
                  :gradient-stops="lineChart4.gradientStops"
                  :extra-options="lineChart4.extraOptions"
                  :height="200"
                >
                </line-chart>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg d-flex">
          <!-- energy -->
          <card type="card-chart">
            <div class="row">
              <div class="col-lg" style="display: inline">
                <h3 class="text-center">ENERGY</h3>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-lg">
                <line-chart
                  :chart-data="lineChart5.chartData"
                  :gradient-colors="lineChart5.gradientColors"
                  :gradient-stops="lineChart5.gradientStops"
                  :extra-options="lineChart4.extraOptions"
                  :height="200"
                >
                </line-chart>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DoubleBounce } from "vue-loading-spinner";
import { BaseButton, Modal } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import LineChart from "src/components/Charts/LineChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    Modal,
    Loading,
    DoubleBounce,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    BaseButton,
    LineChart,
  },
  data() {
    return {
      light: "",
      lights: [
        {
          label: "Light A",
          value: "Light A",
        },
        {
          label: "Light B",
          value: "Light B",
        },
      ],
      lineChart1: {
        chartData: {
          labels: [
            "8:00am",
            "9:00am",
            "10:00am",
            "11:00am",
            "12:00pm",
            "01:00pm",
            "02:00pm",
            "03:00pm",
            "04:00pm",
            "05:00pm",
            "06:00pm",
            "07:00pm",
            "08:00pm",
            "09:00pm",
            "10:00pm",
            "11:00pm",
          ],
          datasets: [
            {
              label: "Total km",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                0, 80, 80, 80, 100, 100, 70, 70, 70, 80, 80, 80, 120, 120, 80,
                80, 80,
              ],
            },
          ],
          lineAtIndex: 5,
        },
        extraOptions: chartConfigs.energyChartOptions,
        loaded: true,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [1, 0.4, 0],
      },
      lineChart2: {
        chartData: {
          labels: [
            "8:00am",
            "9:00am",
            "10:00am",
            "11:00am",
            "12:00pm",
            "01:00pm",
            "02:00pm",
            "03:00pm",
            "04:00pm",
            "05:00pm",
            "06:00pm",
            "07:00pm",
            "08:00pm",
            "09:00pm",
            "10:00pm",
            "11:00pm",
          ],
          datasets: [
            {
              label: "Total km",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                0, 80, 80, 80, 100, 100, 70, 70, 70, 80, 80, 80, 120, 120, 80,
                80, 80,
              ],
            },
          ],
          lineAtIndex: 5,
        },
        extraOptions: chartConfigs.energyChartOptions,
        loaded: true,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0.8, 0.5, 0.2],
      },
      lineChart3: {
        chartData: {
          labels: [
            "8:00am",
            "9:00am",
            "10:00am",
            "11:00am",
            "12:00pm",
            "01:00pm",
            "02:00pm",
            "03:00pm",
            "04:00pm",
            "05:00pm",
            "06:00pm",
            "07:00pm",
            "08:00pm",
            "09:00pm",
            "10:00pm",
            "11:00pm",
          ],
          datasets: [
            {
              label: "Total km",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                0, 80, 80, 80, 100, 100, 70, 70, 70, 80, 80, 80, 120, 120, 80,
                80, 80,
              ],
            },
          ],
          lineAtIndex: 5,
        },
        extraOptions: chartConfigs.energyChartOptions,
        loaded: true,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0.8, 0.5, 0.2],
      },
      lineChart4: {
        chartData: {
          labels: [
            "8:00am",
            "9:00am",
            "10:00am",
            "11:00am",
            "12:00pm",
            "01:00pm",
            "02:00pm",
            "03:00pm",
            "04:00pm",
            "05:00pm",
            "06:00pm",
            "07:00pm",
            "08:00pm",
            "09:00pm",
            "10:00pm",
            "11:00pm",
          ],
          datasets: [
            {
              label: "Total km",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                0, 80, 80, 80, 100, 100, 70, 70, 70, 80, 80, 80, 120, 120, 80,
                80, 80,
              ],
            },
          ],
          lineAtIndex: 5,
        },
        extraOptions: chartConfigs.energyChartOptions,
        loaded: true,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0.8, 0.5, 0.2],
      },
      lineChart5: {
        chartData: {
          labels: [
            "8:00am",
            "9:00am",
            "10:00am",
            "11:00am",
            "12:00pm",
            "01:00pm",
            "02:00pm",
            "03:00pm",
            "04:00pm",
            "05:00pm",
            "06:00pm",
            "07:00pm",
            "08:00pm",
            "09:00pm",
            "10:00pm",
            "11:00pm",
          ],
          datasets: [
            {
              label: "Total km",
              fill: true,
              borderColor: config.colors.primary,
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: config.colors.primary,
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              pointBorderWidth: 20,
              pointHoverRadius: 4,
              pointHoverBorderWidth: 15,
              pointRadius: 4,
              data: [
                0, 80, 80, 80, 100, 100, 70, 70, 70, 80, 80, 80, 120, 120, 80,
                80, 80,
              ],
            },
          ],
          lineAtIndex: 5,
        },
        extraOptions: chartConfigs.energyChartOptions,
        loaded: true,
        gradientColors: config.colors.primaryGradient,
        gradientStops: [0.8, 0.5, 0.2],
      },
      value1: "",
    };
  },
  computed: {},
  methods: {
    validateEndDate() {
    
      var start = moment(this.value1[0]);
      var end = moment(this.value1[1]);
      var diff = end.diff(start, "days");
     

      if (diff > 2) {
        swal({
          title: "Oppss!",
          text: "date cannot exceeds two days",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            
            let a = moment(this.value1[0]).format("YYYY-MM-DD")
          
            let b =   moment(a, "YYYY-MM-DD").add(1, 'days')
            let c = moment(b).format("YYYY-MM-DD")
            this.value1[1] = moment(b).format("YYYY-MM-DD")
            this.value1 = [ start, c]
           
          }
        });
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
.text-inline {
  display: inline;
}
</style>
